<div
    ngbDropdown
    #ctxDropdown="ngbDropdown"
    display="dynamic"
    [container]="parentContainer"
    [autoClose]="autoClose ?? (menuHasLinkedMenu ? 'outside' : true)"
    [placement]="placement"
>
    @if (showButton) {
        <atom-dropdown-button
            ngbDropdownAnchor
            [id]="ctxId"
            [btnClass]="btnClass"
            [altText]="altText"
            [tooltip]="tooltip"
            [disabled]="disabled"
            [hideDropdownChevron]="hideDropdownChevron"
            [cySelector]="cySelector"
            (click)="onClick($event)"
        >
            @switch (buttonStyle) {
                @case (DROPDOWN_BUTTON_STYLE.Result) {
                    @if (selectedMenuItems?.length) {
                        @for (
                            item of selectedMenuItems;
                            track $index;
                            let i = $index
                        ) {
                            <span class="me-2" [attr.data-cy]="item.cySelector">
                                {{
                                    item.translationKey
                                        ? (item.translationKey
                                          | translateTokenisedString)
                                        : item.label
                                }}{{
                                    i < selectedMenuItems.length - 1
                                        ? ',&nbsp;'
                                        : ''
                                }}
                            </span>
                        }
                    }
                    @if (!selectedMenuItems?.length) {
                        <span class="me-2">{{
                            SELECT | translateTokenisedString
                        }}</span>
                    }
                }
                @case (DROPDOWN_BUTTON_STYLE.Label) {
                    <ng-content></ng-content>
                }
            }
        </atom-dropdown-button>
    }

    @if (!disabled) {
        <div
            ngbDropdownMenu
            [class]="size ? 'dropdown-menu-' + size : ''"
            [class.dropdown-menu-search]="hasSearch"
            [attr.aria-labelledby]="ctxId"
        >
            @if (menuTitle) {
                <div class="dropdown-header flex-shrink-0">
                    <h5>
                        {{ menuTitle }}
                    </h5>
                </div>
            }
            @if (hasSearch) {
                <div class="mx-1">
                    <molecule-input-search></molecule-input-search>
                </div>
            }
            <atom-async-data [isLoading]="isLoading">
                <molecule-context-menu
                    [class.dropdown-menu-search-content]="hasSearch"
                    [menu]="menu"
                    [isMulti]="isMulti"
                    [highlightSelected]="highlightSelected"
                    [initialValue]="selectedMenuItemValues"
                    [cySelector]="cySelector"
                    [attr.data-cy]="cySelector + '-menu'"
                    [emitOnlyOnclick]="true"
                    (singleItemSelected)="onSingleItemSelected($event)"
                    (multipleItemsSelected)="onMultipleItemsSelected($event)"
                ></molecule-context-menu>
            </atom-async-data>
        </div>
    }
</div>
